/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModulePermissionScopeFilter } from './modulePermissionScopeFilter';


export interface ModulePermissionIncludeFilterItems { 
    relation?: ModulePermissionIncludeFilterItems.RelationEnum;
    scope?: ModulePermissionScopeFilter;
}
export namespace ModulePermissionIncludeFilterItems {
    export type RelationEnum = 'module' | 'moduleAccesses';
    export const RelationEnum = {
        Module: 'module' as RelationEnum,
        ModuleAccesses: 'moduleAccesses' as RelationEnum
    };
}


